/**
 * 用户信息
 */
export interface IUserInfo {
  userid?: number
  username?: string
  avatar?: string
  developer?: IDeveloper
  phone?: string
  isDeveloper?: boolean
  isPassedDeveloper?: boolean
  isPendingDeveloper?: boolean
  isRejectedDeveloper?: boolean
}

/**
 * 开发者信息
 */
export interface IDeveloper {
  developer_id?: number
  developer_name?: string
  website?: string
  business_license?: string
  approve_info?: string
  contacts?: string
  phone?: string
  email?: string
  status?: EDeveloperStatus
}

/**
 * 开发者审核状态
 */
export enum EDeveloperStatus {
  REJECTED = -1, // 被拒绝
  PENDING, // 未认证
  PASSED // 已认证
}

export interface IUserState {
  userInfo: IUserInfo
}
